import React, { useState, useEffect } from 'react'
import { getData } from '../../helpers/api';
import moment from 'moment';
import { useNavigate, useLocation } from 'react-router-dom'
import { EditorState } from 'draft-js';

import {
    CBadge,
    CButton,
    CButtonGroup,
    CCard,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCol,
    CProgress,
    CRow,
    CCallout
} from 'compat/coreui'

export default function About(props) {
    const [orderData, setOrderData] = useState([])

    const navigate = useNavigate();
    const [userData, setUserData] = useState({})
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [showHours, setShowHours] = useState(false);
    const [businessName, setBusinessName] = useState("");
    const [businessType, setBusinessType] = useState("");
    const [businessEmail, setBusinessEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [webUrl, setWebUrl] = useState("");
    const [address, setAddress] = useState("");
    const [address2, setAddress2] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [operationTime, setOperationTime] = useState("");
    const [pincode, setPincode] = useState("");
    const [fax, setFax] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [alternatePhone, setAlternatePhone] = useState("");
    const [alternateEmail, setAlternateEmail] = useState("");
    const [img, setImage] = useState("");
    const [headline, setHeadline] = useState("");
    const [locationState, setLocationState] = useState("");

    useEffect(() => {
        getOrders()
    }, [])

    const getOrders = () => {
        getData(`${process.env.REACT_APP_APP_API_URL}/api/order`).then(res => {
            console.log(res)
            setOrderData(res.data.orders);
        }).catch(e => console.log(e))
    }

    const setPic = (selectedImg) => {
        console.log("Image---->>> ", selectedImg);
        setImage(URL.createObjectURL(selectedImg))
    }
    getData(`${process.env.REACT_APP_APP_API_URL}/api/user`).then(res => {
        setPincode(res.data.user.zip_code)
        setAddress(res.data.user.address1)
        setCity(res.data.user.city)
        setState(res.data.user.state)
        if (res.data.user.state == "SELLER") {
            setHeadline("Business Information")
            setLocationState(false)
        } else {
            setHeadline("Profile Information")
            setLocationState(true)
        }
    }).catch(console.log)
    return (
        <>
            <ul className="c_8 timeline">
                <li id="new_post">
                    <div className="box add">
                        <span className="title">Profile Information</span>
                        <CRow className="text-start">
                            <CCol md sm="12" className="mb-sm-2 mb-0">
                                <CCard style={{ padding: "5%", borderWidth: "medium" }}>
                                    <div className="text-muted text-center" style={{ fontWeight: "600" }} >{headline}</div>
                                    <div>
                                        <strong style={{ color: "#444", fontSize: "80%", marginRight: "5px" }}>Address:</strong>
                                        <strong style={{ color: "gray", fontSize: "90%" }}>PREMIUM</strong>
                                    </div>
                                    <div>
                                        <strong style={{ color: "#444", fontSize: "80%", marginRight: "5px" }}>Address2:</strong>
                                        <strong style={{ color: "gray", fontSize: "90%" }}>(unknown)</strong>
                                    </div>
                                    <div>
                                        <strong style={{ color: "#444", fontSize: "80%", marginRight: "5px" }}>City:</strong>
                                        <strong style={{ color: "gray", fontSize: "90%" }}>{city}</strong>
                                    </div>
                                    <div>
                                        <strong style={{ color: "#444", fontSize: "80%", marginRight: "5px" }}>State:</strong>
                                        <strong style={{ color: "gray", fontSize: "90%" }}>{state}</strong>
                                    </div>
                                    <div>
                                        <strong style={{ color: "#444", fontSize: "80%", marginRight: "5px" }}>Zip:</strong>
                                        <strong style={{ color: "gray", fontSize: "90%" }}>{pincode}</strong>
                                    </div>
                                </CCard>

                            </CCol>
                            {locationState ?
                                <CCol md sm="12" className="mb-sm-2 mb-0">
                                    <CCard style={{ padding: "5%", borderWidth: "medium" }}>
                                        <div className="text-muted text-center" style={{ fontWeight: "600" }} >Business Location</div>
                                        <div>
                                            <strong style={{ color: "#444", fontSize: "80%", marginRight: "5px" }}>Address:</strong>
                                            <strong style={{ color: "gray", fontSize: "90%" }}>PREMIUM</strong>
                                        </div>
                                        <div>
                                            <strong style={{ color: "#444", fontSize: "80%", marginRight: "5px" }}>Address2:</strong>
                                            <strong style={{ color: "gray", fontSize: "90%" }}>(unknown)</strong>
                                        </div>
                                        <div>
                                            <strong style={{ color: "#444", fontSize: "80%", marginRight: "5px" }}>City:</strong>
                                            <strong style={{ color: "gray", fontSize: "90%" }}>{city}</strong>
                                        </div>
                                        <div>
                                            <strong style={{ color: "#444", fontSize: "80%", marginRight: "5px" }}>State:</strong>
                                            <strong style={{ color: "gray", fontSize: "90%" }}>{state}</strong>
                                        </div>
                                        <div>
                                            <strong style={{ color: "#444", fontSize: "80%", marginRight: "5px" }}>Zip:</strong>
                                            <strong style={{ color: "gray", fontSize: "90%" }}>{pincode}</strong>
                                        </div>
                                    </CCard>

                                </CCol>
                                : <div></div>
                            }
                        </CRow>
                        {
                            locationState ?
                                <CCol md sm="12" className="mb-sm-2 mb-0">
                                    <CCard style={{ padding: "5%", borderWidth: "medium" }}>
                                        <div className="text-muted text-center" style={{ fontWeight: "600" }} >Manager Information</div>
                                        <div>
                                            <strong style={{ color: "#444", fontSize: "80%", marginRight: "5px" }}>First Name:</strong>
                                            <strong style={{ color: "gray", fontSize: "90%" }}>PREMIUM</strong>
                                        </div>
                                        <div>
                                            <strong style={{ color: "#444", fontSize: "80%", marginRight: "5px" }}>Email:</strong>
                                            <strong style={{ color: "gray", fontSize: "90%" }}>(unknown)</strong>
                                        </div>
                                        <div>
                                            <strong style={{ color: "#444", fontSize: "80%", marginRight: "5px" }}>Phone:</strong>
                                            <strong style={{ color: "gray", fontSize: "90%" }}>$0.00</strong>
                                        </div>

                                    </CCard>

                                </CCol>
                                : <div></div>
                        }
                    </div>
                </li>
            </ul>
        </>
    )
}